// src/app/router/guards/DevGuard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '@/shared/hooks/usePermission';

export function DevGuard({ children }: { children: React.ReactNode }) {
  const hasDev = usePermission('dev-tools');
  if (!hasDev) return <Navigate to="/" replace />;
  return <>{children}</>;
}
